import { render, staticRenderFns } from "./edicao_prod_serv.vue?vue&type=template&id=092b9af3&scoped=true&"
import script from "./edicao_prod_serv.vue?vue&type=script&lang=js&"
export * from "./edicao_prod_serv.vue?vue&type=script&lang=js&"
import style0 from "./edicao_prod_serv.vue?vue&type=style&index=0&id=092b9af3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092b9af3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VForm,VProgressCircular,VSwitch,VTextField})
